<template>
  <div>
    <vb-form-row item-name="クーポンコード" id="row-campaign-code">
      <template #input>
        <v-sheet class="col-12 pa-0" max-width="320">
          <validation-provider v-slot="{ errors }" rules="max:20|alpha_num_org" name="クーポンコード"
                               ref="couponCodeProvider">
            <v-text-field
                :value="formItemsGetter.campaignCode"
                v-model="formItemsGetter.campaignCode"
                @input="mutateCouponCode"
                @blur="couponCodeProviderValidation($event.target.value)"
                :error-messages="errors"
                outlined
                dense
                height="44px"
                hide-details="auto"
                :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
            ></v-text-field>
            <v-card-text v-if="formLabelsGetter.formattedCampaignName"
                         id="applied-coupon"
                         class="pt-2 pl-0 error--text caption"
            >
              {{ formLabelsGetter.formattedCampaignName }}が適用されます。
            </v-card-text>
          </validation-provider>
        </v-sheet>
      </template>
    </vb-form-row>
  </div>
</template>

<script>
import VbFormRow from "../buy/vb-form-row.vue";
import InputValueConversion from "../../../libs/InputValueConversion.js";
import {mapGetters, mapActions, mapMutations} from 'vuex';

export default {
  name: "vb-coupon-code",
  components: {VbFormRow},
  inject: ['setErrors'],
  async created() {
    await this.initCouponCodeFromCookies();
  },
  props: {
    buyNumber: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      getMemberFormItems: 'member/getFormItems',
      getBuyFormItems: 'buy/getFormItems',
      getBuyFormLabels: 'buy/getFormLabels',
    }),
    formItemsGetter() {
      return this.getBuyFormItems;
    },
    formLabelsGetter() {
      return this.getBuyFormLabels;
    },
  },
  methods: {
    ...mapActions({
      setBuyFormItems: 'buy/updateFormItems',
      setBuyFormLabels: 'buy/updateFormLabels',
    }),
    ...mapMutations({
      setCouponExpirationDate: 'buy/mutateCouponExpirationDate',
    }),
    formItemsSetter({name, value}) {
      this.setBuyFormItems({name, value});
    },
    formLabelsSetter({name, value}) {
      this.setBuyFormLabels({name, value});
    },
    mutateCouponCode(event) {
      this.$nextTick(() => {
        const trimmed = this.fullWidthToHalfWidthAlphanum(event.trim());

        this.formItemsSetter({name: 'campaignCode', value: trimmed});
        if (!trimmed) {
          this.formLabelsSetter({name: 'formattedCampaignName', value: ''});
        }
      });
    },
    async couponCodeProviderValidation(inputCode) {
      let providerValidationResult = false;
      if (this.$refs.couponCodeProvider) {
        providerValidationResult = await this.$refs.couponCodeProvider.validate();
      }
      if (providerValidationResult.valid) {
        await this.retrieveCouponCode(inputCode);
      } else {
        this.formLabelsSetter({name: 'formattedCampaignName', value: ''});
      }
    },
    async retrieveCouponCode(inputCode) {
      const [validationResult, appliedCoupon, errorMessage, shippingFree, expiresAt] = await this.validateCouponCode(inputCode);
      if (validationResult !== true) {
        this.formLabelsSetter({name: 'formattedCampaignName', value: ''});
        this.setErrors('クーポンコード', errorMessage);
      }
      if (appliedCoupon) {
        this.formLabelsSetter({name: 'formattedCampaignName', value: appliedCoupon});
      }
      if (!inputCode) {
        this.formLabelsSetter({name: 'isShippingFree', value: false});
      } else {
        this.formLabelsSetter({name: 'isShippingFree', value: shippingFree});
      }
      this.setCouponExpirationDate(expiresAt);
      return validationResult;
    },
    async validateCouponCode(code) {
      if (!code) {
        return [true, null];
      }
      return axios.post('/api/buy/validateCouponCode', {
        "campaign_code": code,
        "site_code": this.$siteCode,
        "email": this.getMemberFormItems.email,
        "buy_id": this.buyNumber,
      }).then(response => {
        if (!response.data.result) {
          return [false, null, response.data.campaignErrorMessage, false, null];
        }
        return [true, response.data.campaignName, null, response.data.shippingFree, response.data.expiresAt];

      }).catch(e => {
        console.error({e});

        if (400 <= e.response.status && e.response.status <= 499) {
          return [false, null, 'サーバと通信できませんでした。電波状況の良いところで再度お試しください。', false, null];

        } else if (500 <= e.response.status && e.response.status <= 599) {
          return [false, null, 'サーバと通信できませんでした。しばらく時間をおいてからもう一度アクセスして頂くか、管理者にお問い合わせください。', false, null];
        }
        return [false, null, 'サーバと通信できませんでした。しばらく時間をおいてからもう一度アクセスして頂くか、管理者にお問い合わせください。', false, null];
      });
    },
    fullWidthToHalfWidthAlphanum(value) {
      return InputValueConversion.fullWidthToHalfWidthAlphanum(value);
    },
    async initCouponCodeFromCookies() {
      // Early return if campaign code already exists
      if (this.formItemsGetter.campaignCode) {
        return;
      }

      const code = this.getCouponCode();

      if (!code) {
        await this.handleNoCouponCode();
        return;
      }

      await this.processCouponCode(code);
    },
    getCouponCode() {
      // Get coupon code from cookie
      const cookieValue = document.cookie;
      const splitVal = cookieValue.split('; ');
      const keyCode = splitVal.find(row =>
          row.startsWith(VueConfig.couponKeyForCookies.buy.cookieName)
      );
      let code = keyCode ? keyCode.split('=')[1] : null;

      // Check URL parameters for coupon code
      const searchParamsCouponCode = new URLSearchParams(window.location.search)
          .get(VueConfig.couponKeyForCookies.buy.urlParamsName);

      // URL parameters take precedence over cookies
      return (searchParamsCouponCode && searchParamsCouponCode !== code)
          ? searchParamsCouponCode
          : code;
    },
    async handleNoCouponCode() {
      this.formLabelsSetter({
        name: 'isRequestParamCoupon',
        value: false
      });
      this.formLabelsSetter({
        name: 'requestParamCouponCode',
        value: null
      });

      const defaultCouponCode = this.setDefaultCouponCodeByRoute();
      await this.retrieveCouponCode(defaultCouponCode);
    },
    async processCouponCode(code) {
      // Set initial coupon state
      this.mutateCouponCode(code);
      this.formLabelsSetter({
        name: 'isRequestParamCoupon',
        value: true
      });
      this.formLabelsSetter({
        name: 'requestParamCouponCode',
        value: code
      });

      const validationResult = await this.retrieveCouponCode(code);

      if (validationResult) {
        await this.handleValidCoupon();
      } else {
        await this.handleInvalidCoupon();
      }
    },
    async handleValidCoupon() {
      const couponName = this.formLabelsGetter.formattedCampaignName;
      this.formLabelsSetter({
        name: 'requestParamCouponName',
        value: couponName
      });
    },
    async handleInvalidCoupon() {
      this.formLabelsSetter({
        name: 'isRequestParamCouponError',
        value: true
      });

      const defaultCouponCode = this.setDefaultCouponCodeByRoute();
      await this.retrieveCouponCode(defaultCouponCode);
    },
    routeResolve(name) {
      const route = this.$router.resolve({
        name: name,
      }).href
      if (this.$routerBase) {
        const reg = new RegExp("^" + this.$routerBase);
        const url = route.replace(reg, "")
        return '/' + url
      } else {
        return route
      }
    },
    // routeによってデフォルトのクーポンが違う
    setDefaultCouponCodeByRoute() {
      //FIXME 結局valuebooks.jpしかデフォルトクーポンはないので、このメソッドはどうなのか・・
      const routeCouponMappings = {
        [this.routeResolve("QuickEntryVbForm")]: {
          [VueConfig.siteCode.valuebooks]: VueConfig.sell.defaultCouponCode.LP,
        }
      };

      const defaultCouponCode = routeCouponMappings[this.$route.path]?.[this.$siteCode] || '';

      this.formItemsSetter({
        name: 'campaignCode',
        value: defaultCouponCode
      });

      return defaultCouponCode;
    },
  },
  mounted() {
    if (this.formItemsGetter.campaignCode) {
      this.couponCodeProviderValidation(this.formItemsGetter.campaignCode)
    }
  }
}
</script>

<style scoped>

</style>